import { ISearchData } from '.';
import { IDataService, DataService } from '../services';

export class SearchData {
    private _dataService: IDataService = new DataService();

    public Division(): Promise<ISearchData[]> {
        return this.division();
    }

    public DocumentType(): Promise<ISearchData[]> {
        return this.documentType();
    }

    public Agency(): Promise<ISearchData[]> {
        return this.agency();
    }

    public Languages(): ISearchData[] {
        let languages = [
            { key: 'all', text: 'all', value: 'all' }
        ];

        return languages;
    }

    private async division(): Promise<ISearchData[]> {
        let division: ISearchData[] = [];

        await this._dataService.CallDivisionApi().then(data => {
            return data.map((_division, index) => {
                division.push({
                    key: _division.DivisionName + index, text: _division.DivisionName, value: _division.DivisionName
                });
            });
        });

        return division;
    }

    
    private async documentType(): Promise<ISearchData[]> {
        let documentType: ISearchData[] = [];

        await this._dataService.CallDocumentTypeApi().then(data => {
            return data.map((_documentType, index) => {
                documentType.push({
                    key: _documentType.DocumentTypeName + index, text: _documentType.DocumentTypeName, value: _documentType.DocumentTypeName
                });
            });
        });

        return documentType;
    }

    private async agency(): Promise<ISearchData[]> {
        let agency: ISearchData[] = [
            {key: '0', text: 'Agency', value: 'non'}
        ];

        await this._dataService.CallAgenciesApi().then(data => {
            return data.map((_agency, index) => {
                agency.push({
                    key: _agency.AgencyName + index.toString(), text: _agency.AgencyName, value: _agency.AgencyName
                });
            });
        });

        return agency;
    }
}